/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetCompanyToHireResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'CompanyToHireInfo',
        isRequired: true,
      },
    },
  }],
} as const;
